/**
 * The criterion's one state: proved by Cofactor (green), checked another way (grey)
 * not proved (amber: a warning) or failed (red: a run failed).
 *
 * @module features/proofs/components/OutcomeBadge
 */
import React from 'react';
import { Badge } from '@chatsdet/ui';
import type { CriterionState } from '@chatsdet/types';

const OUTCOME_BADGE = {
  proved: { variant: 'success', label: 'Proved by Cofactor' },
  'checked-another-way': { variant: 'secondary', label: 'Checked another way' },
  'not-proved': { variant: 'warning', label: 'Not proved' },
  failed: { variant: 'destructive', label: 'Failed' },
} as const;

export const OutcomeBadge: React.FC<{ state: CriterionState }> = ({ state }) => (
  <Badge variant={OUTCOME_BADGE[state].variant} size="sm" data-testid="criterion-outcome">
    {OUTCOME_BADGE[state].label}
  </Badge>
);
